import { useState, useEffect, ReactNode } from 'react';
import styled from 'styled-components';

import BodyPortal from '../BodyPortal';

type ContainerProps = {
  visible: boolean;
  width?: number;
};
const Container = styled.div<ContainerProps>`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: ${(props): string => props.theme.colors.white};
  border-top: 3px solid ${(props): string => props.theme.colors.primary};
  width: ${({ width = 378 }) => width}px;
  z-index: 2147483002;
  padding: 20px 34px 20px 20px;
  box-shadow: 0px 2px 8px ${(props): string => props.theme.colors.boxShadow};
  border-radius: 0px 0px 4px 4px;
  transform: scale(${(props): number => (props.visible ? 1 : 0.1)});
  transition: all 0.3s ease;
  transform-origin: bottom right;
`;

type Props = {
  children: ReactNode;
  width?: number;
};

const PopupSurveyContainer = ({ children, width }: Props) => {
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setRendered(true), 0);
    return (): void => clearTimeout(timeoutId);
  }, []);

  return (
    <BodyPortal>
      <Container visible={rendered} width={width}>
        {children}
      </Container>
    </BodyPortal>
  );
};

export default PopupSurveyContainer;
